import React, { useState } from 'react';

const LayoutContext = React.createContext();

export { LayoutContext };

function LayoutContextContainer(props) {
  const [toPath, setToPath] = useState('');
  const [promoNotif, setPromoNotif] = useState(0);

  return (
    <LayoutContext.Provider value={{
      toPath,
      setToPath,
      promoNotif,
      setPromoNotif,
    }}
    >
      { props.children }
    </LayoutContext.Provider>
  );
}

export default LayoutContextContainer;
